import {
  REQUEST_WEATHER_DATA,
  RECEIVE_WEATHER_DATA,
  FAILURE_WEATHER_DATA,
  REQUEST_WEATHER_OBSERVATIONS,
  RECEIVE_WEATHER_OBSERVATIONS,
} from '../constants/actionTypes';

export function reqWeatherData() {
  return {
    type: REQUEST_WEATHER_DATA,
  };
}

export function receiveWeatherData(data) {
  return {
    type: RECEIVE_WEATHER_DATA,
    data,
  };
}

export function failureWeatherData() {
  return {
    type: FAILURE_WEATHER_DATA,
  };
}

export function reqObservations(fieldId, season, useMicrosoftGDD = false) {
  return {
    type: REQUEST_WEATHER_OBSERVATIONS,
    fieldId,
    season,
    useMicrosoftGDD
  };
}

export function receiveObservationsData(response, season, useMicrosoftGDD) {
  return {
    type: RECEIVE_WEATHER_OBSERVATIONS,
    response,
    season,
    useMicrosoftGDD
  };
}

export function failureWeatherObservationsData() {
  return {
    type: FAILURE_WEATHER_DATA,
  };
}
